export default "__VITE_ASSET__Csqw5jBM__"